import DataStore from './DataStore';
import UiStore from './UiStore';

let dataStore, uiStore;

export const getStoreInstances = () => {
  const _dataStore = dataStore ?? new DataStore();
  const _uiStore = uiStore ?? new UiStore();

  _uiStore.connectStores({ dataStore: _dataStore });
  _dataStore.connectStores({ uiStore: _uiStore });

  if (typeof window === 'undefined')
    return {
      dataStore: _dataStore,
      uiStore: _uiStore,
    };

  if (!dataStore) dataStore = _dataStore;
  if (!uiStore) uiStore = _uiStore;

  if (global.window) {
    window.ds = dataStore;
    window.us = uiStore;
  }

  return { dataStore, uiStore };
};

